export default {"src":"/_next/static/media/boomNoBackground_64.562be86e.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};